module.exports = __webpack_public_path__ + "static/media/basel-12.10748666.jpg";